import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-cropper-modal',
  templateUrl: './image-cropper-modal.component.html',
  styleUrls: ['./image-cropper-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageCropperModalComponent {
  private activeModal = inject(NgbActiveModal);

  public croppedFile: File | null = null;
  public imageFile: File | null = null;

  public discardUpload(): void {
    this.activeModal.close(null);
  }

  public confirmCroppedImage(): void {
    this.activeModal.close(this.croppedFile);
  }

  public imageCropped(event: ImageCroppedEvent) {
    if (event.blob && this.imageFile) {
      this.croppedFile = new File([event.blob], this.imageFile.name, {
        type: this.imageFile.type,
        lastModified: Date.now()
      });
    } else {
      this.croppedFile = null;
    }
  }
}
